import * as React from 'react';
import CellBase from './cell-base';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
export var ProductTableHeaderImage = function ProductTableHeaderImage(_ref) {
  var children = _ref.children;
  return _jsx(CellBase, {
    mobileOrder: 0,
    sx: {
      display: ['none', 'flex'],
      alignItems: 'center',
      justifyContent: 'center',
      marginLeft: -8,
      variant: 'compounds.product-table.headerImage'
    },
    children: _jsx("div", {
      sx: {
        position: 'relative',
        height: '100%',
        width: '100%',
        marginBottom: -6,
        img: {
          maxHeight: 67,
          maxWidth: [121, 174],
          margin: 'auto',
          objectFit: 'contain'
        }
      },
      children: children
    })
  });
};
export default ProductTableHeaderImage;
//# sourceMappingURL=header-image.js.map